import React from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '@/components/Icons/Close';
import { Info } from '@/components/Icons/Info';
import { LoadingOverlay } from '@/components/LoadingOverlay';
import type { Notice } from '@/types/user';
import { sanitizeRichTextHtml } from '@/utils/html';

interface Props {
  notice: Notice;
  isPending: boolean;
  onClose: () => void;
}

export const NoticeBanner: React.FC<Props> = ({
  notice,
  isPending,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <div className="px-4 pt-3 md:px-6 md:pt-6">
      <div className="relative flex flex-col gap-2 rounded-xl border border-purple-soft bg-card p-4 shadow-card contrast:border-border">
        <div className="inline-flex w-fit items-center gap-1 rounded-xl border border-transparent bg-purple-soft py-[2px] pr-2 pl-1 text-caption-12 text-primary contrast:border-border">
          <Info className="size-4 shrink-0" />
          {t('home.noticeBanner.label')}
        </div>
        <div
          className="rich-text text-body-16 text-muted-foreground"
          dangerouslySetInnerHTML={{
            __html: sanitizeRichTextHtml(notice.text),
          }}
        />
        <button
          type="button"
          aria-label={t('home.noticeBanner.closeAria')}
          className="absolute top-3 right-3 flex size-4 cursor-pointer items-center justify-center text-muted-foreground"
          onClick={onClose}
        >
          <Close className="size-4" />
        </button>
        {isPending && <LoadingOverlay />}
      </div>
    </div>
  );
};
